import { FabIcons, FadIcons, FarIcons, FasIcons, Library } from '@playbooks/icons';

Library({ ...FabIcons, ...FadIcons, ...FarIcons, ...FasIcons });
